import { useEffect, useState } from "react";
import apiService from "Services/apiService";
import TableRender from "components/common/TableRender/TableRender"
import { SkeTable } from "components/common/Skeleton/SkeTable";
import Search from "components/common/Search/Search";
import polizaImg from "assets/img/polizasStock.svg";
import { DownloadDOC } from 'Utils/Fn/DownloadDOC';

import { DynamicRow } from "Interface/generic.model";
import e from "./style.module.css";
import ModalmarbeteInv from "./Modal/ModalmarbeteInv";
import AlertNotification, {IAlert} from "components/common/AlertNotification/AlertNotification";

export const PoliciesIndividualList = () => {
  
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] =  useState<IAlert>({ show: false, title: '', details: '', variant: 'Danger' });
  const [allPolicies, setAllPolicies] = useState<any[]>([]);
  const [policies, setPolicies] = useState<any[]>([]);
  const [show, setShow] = useState(false);
  const [selectedElement, setSelectedElement] = useState<any>(null);
  const [selectedRamoFilter, setSelectedRamoFilter] = useState<string | null>(null);
  const [inputFilter, setInputFilter] = useState<string | null>(null);
  const [disableDocsBtn, setDisableDocsBtn] = useState<{ [key: string]: boolean }>({});
  

  const POLICIES_TABLE_ROWS = [
    {label: 'Cód. Póliza', key: 'codPoliza'},
    {label: 'Aseguradora', key: 'aseguradora'},
    {label: 'Nro. Póliza', key: 'numPoliza'},
    {label: 'Ramo', key: 'ramo'},
    {label: 'Prima', key: '_prima', class: 'text-right', classBody: 'text-right'},
    {label: 'Fin de vigencia', key: 'fin_de_Vigencia'},
  ];
  const SLOT = {label: 'Acciones', key: 'fleetsSlot', slotName: 'fleetsSlot', class: 'text-center'};

  useEffect(() => {
    apiService({
      name: 'getPoliciesCop',
      queryParams: {_codigoCliente: JSON.parse(localStorage.getItem('cliCod')||'{}') || ''},
      onSuccess: ({response}) => {
        const resp = response.map((data: any) => (
          {...data,
            id: data.emisionesId,
            _prima: '$' + data.prima
          }
        ));
        setAllPolicies(resp);
        setPolicies(resp);
      },
      onError: (error) => {
        console.error('Error:', error);
        setAlert({
          show: true,
          title: 'Error al obtener datos',
          details: error,
          variant: 'Danger'
        })
      },
      onFinally() {
        setLoading(false);
      }
    });
  }, []);

  const resetAlert = () => {
    setAlert(prev => ({ ...prev, show: false }));
  };

  const downloadDocs = (data: any) => {
    // FAlta validar la data q se envia en query ya q es dummy data
    setDisableDocsBtn((prevDisableBtn) => ({ ...prevDisableBtn, [data.idNew]: true }));
    apiService({
      name: 'downloadFhysicalFiles',
      queryParams: { _codigoPoliza: data.codPoliza , _nombreArchivo: data._completo  },
      onSuccess: (resp) => {
        DownloadDOC(resp, `${data._nombre}.pdf`)
      },
      onError: (error) => {
        setAlert({
          show: true,
          title: 'Error al intentar descarger el documento',
          details: error,
          variant: 'Danger'
        })
      },
      onFinally() {
        setDisableDocsBtn((prevDisableBtn) => ({ ...prevDisableBtn, [data.idNew]: false }));
      }
    });
  };

  const fleetsSlotBtn = (row: DynamicRow) => {
    return (
      row.chasis ? <div className={e.individualIconTable}>
        {/* <button
          type="button"
          id={row.codPoliza}
          className={`btn btn-link primary-text ${e['btn_slot-modal']}`}
          data-bs-toggle="tooltip" data-bs-placement="top" title="Descargar condiciones particulares"
          disabled={disableDocsBtn[row.codPoliza]}
          onClick={() => downloadDocs(row)}
        >
          {
            !disableDocsBtn[row.idNew]
            ? (<i className="bi bi-filetype-doc"></i>)
            : (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>)
          }
        </button> */}
        <button
          type="button"
          id={row.id}
          className={`btn btn-link primary-text ${e['btn_slot-modal']}`}
          data-bs-toggle="tooltip" data-bs-placement="top" title="Visualizar el marbete provisional"
          onClick={() => openModal(row)}
        >
          <i className="bi bi-card-heading"></i>
        </button>
      </div>
      : <span className="text-center d-flex justify-content-center">-</span>
    );
  };

  const openModal = (selectData: DynamicRow) => {
    setSelectedElement(selectData);
    setShow(true);
  };

  

  const filterBy = (fil: string, e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
    const searchValue = e.target.value
    if (!searchValue && !selectedRamoFilter && !inputFilter) {
      setAllPolicies(policies)
    }
    const isSelect = e.target.type === 'select-one';
    const saveValue = isSelect ? inputFilter : selectedRamoFilter
    const colSave = isSelect ? 'numPoliza' : 'ramo'
    setAllPolicies(
      policies.filter((item) => {
        if (!!saveValue) {
          return item[fil].toLowerCase().startsWith(searchValue.toLowerCase()) &&
          item[colSave].toLowerCase().startsWith(saveValue.toLowerCase());
        } else {
          return item[fil].toLowerCase().startsWith(searchValue.toLowerCase());
        }
      })
    );
  };

  return (
    <>
      <div className="container pb-3">
        <section className="row">
          <div className="col-md-4 col-lg-3">
            <img
              src={polizaImg}
              alt="Imagen vector de archivo con folder"
              className={e.img_polizas}
            />
          </div>
          <div className="col-md-8 col-lg-9 text-center text-md-start">
            <h3>Pólizas</h3>
            <p className="mb-1">Consulta de pólizas y descarga marbete.</p>
            <div className="d-flex justify-content-center justify-content-md-start">
              <span className="deco_line" />
            </div>
            <div className="row mt-3 mt-md-5 px-3 p-md-1">
              <div className="col-lg-5">
                <label className="bold">
                  Ver solo:
                </label>
                <select 
                  className="form-select text-capitalize"
                  aria-label="Ver solo - póliza"
                  onChange={(e) => {
                    setSelectedRamoFilter(e.target.value);
                    filterBy("ramo", e);
                  }}
                >
                  <option value="">Todos los ramos</option>
                  {policies.length >= 1 && Array.from(
                    new Set(policies.map((obj) => obj.ramo.toLowerCase()))
                  ).map((type, i) => (
                    <option
                      key={`${type}_${i}`}
                      value={type}
                    >
                      {type}
                    </option>
                  ))}
                </select >
              </div>
              <div className="col-lg-5">
                <Search
                  onChange={(e) => {
                    setInputFilter(e.target.value)
                    filterBy("numPoliza", e)
                  }}
                  label="Buscar por número de póliza"
                  placeholder="Número de póliza"
                  disabled={loading}
                />
              </div>
            </div>
          </div>
        </section>
      </div>

      <div className={`pt-4 pb-5 container-fluid ${e.table_ctn}`}>
        <div className="container">
          { loading ? (
            <SkeTable
              col={10}
              row={8}
              className="pt-1"
            />
          ) : (
            <div className={e['table-container']}>
              <TableRender
                id="PolicesListTable"
                schema={[...POLICIES_TABLE_ROWS, SLOT]}
                rows={allPolicies}
                slots={{
                  'fleetsSlot': fleetsSlotBtn
                }}
              />
            </div>
            
          )}
        </div>
      </div>

      <ModalmarbeteInv show={show} handleClose={() => setShow(false)} mData={selectedElement}/>
      <AlertNotification
        show={alert?.show}
        title= {alert?.title}
        details= {alert?.details}
        variant={alert?.variant}
        onClose={resetAlert}
      />
    </>
  );
};
